import { commonTranslationJA } from "@common/translations/ja";

export const spreadsheetDetailsJA = {
  ...commonTranslationJA,
  'Edit': '編集',
  'Load Fmt': 'フォーマットを読み込む',
  'Save Fmt': 'フォーマットを保存',
  'Export': 'エクスポート',
  'Import': 'インポート',
  'Batch Letters': '一括レター',
  'Batch Invites': '一括招待',
  'Count': 'カウント',
  'Undo': '元に戻す',
  'Redo': 'やり直す',
  'Import more': 'さらにインポート',
  'numberOfMatchedColumns': 'インポートファイル内の一意の識別子でスプレッドシートの列と一致する数',
  'Data Options': 'データオプション',
  'Import blank cells over existing data': '既存データに空白セルをインポート',
  'Import blank cells': '空白セルをインポート',
  'Import into tables only': 'テーブルのみにインポート',
  'Tab Delimited': 'タブ区切り',
  'Comma Delimited': 'カンマ区切り',
  'Other (specify delimiter)': 'その他（区切り文字を指定）',
  'Data Import Definition': 'データインポート定義',
  'Import Data': 'データをインポート',
  'Import Warnings': 'インポート警告',
  'Importing individual data': '個人データをインポート中',
  'Importing pedigree data': '系譜データをインポート中',
  'Rows imported': 'インポートされた行',
  'out of': 'のうち',
  'imported successfully': '正常にインポートされました',
  'Failed to import data': 'データのインポートに失敗しました',
  'Load Pedigree Spreadsheet Format': '系譜スプレッドシートフォーマットを読み込む',
  'Load Individual Spreadsheet Format': '個人スプレッドシートフォーマットを読み込む',
  'Individual Data Folders': '個人データフォルダー',
  'Failed to get folders': 'フォルダーの取得に失敗しました',
  'Failed to get fields': 'フィールドの取得に失敗しました',
  'No': 'いいえ',
  'Yes': 'はい',
  'Are you sure you wish to remove all query clauses?': 'すべてのクエリ条件を削除してもよろしいですか？',
  'Drag Fields From Warehouse And Drop Here': '倉庫からフィールドをドラッグしてここにドロップ',
  'No data': 'データなし',
  'No folders': 'フォルダーなし',
  'Columns': '列',
  'Move Fields From Columns Panel Above': '上の列パネルからフィールドを移動',
  'The folder {folderName} already exists. Please enter a different name': 'フォルダー {folderName} は既に存在します。別の名前を入力してください',
  'Please select fields to run the spreadsheet': 'スプレッドシートを実行するには、フィールドを選択してください',
  'Or': 'または',
  'Save Pedigree Spreadsheet Format': '系譜スプレッドシートフォーマットを保存',
  'Save Individual Spreadsheet Format': '個人スプレッドシートフォーマットを保存',
  'Text (Tab Delimited)': 'テキスト（タブ区切り）',
  'Text (Comma Delimited)': 'テキスト（カンマ区切り）',
  'Text (Other)': 'テキスト（その他）',
  'Excel (xls)': 'Excel（xls）',
  'Excel (xlsx)': 'Excel（xlsx）',
  'Include Column Headings': '列見出しを含める',
  'Export Table Rows Only': 'テーブルの行のみエクスポート',
  'Export One Row Per Individual': '個人ごとに1行エクスポート',
  'Retain newlines in formatted cells': '書式付きセルの改行を保持',
  'Convert newlines to spaces': '改行をスペースに変換',
  'Export newlines without any formatting': '書式なしで改行をエクスポート',
  'Export Data': 'データをエクスポート',
  'Settings': '設定',
  'Delimiter': '区切り文字',
  'Options': 'オプション',
  'Newline Handling for Text Fields': 'テキストフィールドの改行処理',
  'Exporting': 'エクスポート中',
  'Failed to export': 'エクスポートに失敗しました',
  'Failed to get individual folders': '個人フォルダーの取得に失敗しました',
  'Failed to get pedigree folders': '系譜フォルダーの取得に失敗しました',
  'The Questionnaire invitation emails were successfully submitted': 'アンケート招待メールが正常に送信されました',
  'The Questionnaire invitation emails were successfully submitted for all individuals with a valid email address.': '有効なメールアドレスを持つすべての個人にアンケート招待メールが正常に送信されました。',
  'No folder selected. Please select a folder first.': 'フォルダが選択されていません。まずフォルダを選択してください。',
  'No individuals found in the current spreadsheet view': '現在のスプレッドシートビューに個人が見つかりません',
  'Failed to load individuals from spreadsheet': 'スプレッドシートから個人の読み込みに失敗しました',
  'Invitations sent to {emailsSent} individuals. Failed to send to {failedCount} individuals due to invalid email addresses: {failedNames}': '{emailsSent}人の個人に招待を送信しました。無効なメールアドレスのため{failedCount}人の個人への送信に失敗しました: {failedNames}',
  'There was a problem with the email addresses for the following individuals': '以下の個人のメールアドレスに問題がありました:',
  'Failed to send invitations': '招待の送信に失敗しました',
  'The spreadsheet could not be run because a comparison operator is missing a value for the following field(s) in the query. Please fix this error and re-run the spreadsheet': 'クエリ内の次のフィールドに比較演算子の値が不足しているため、スプレッドシートを実行できません。エラーを修正して再実行してください',
  'spreadsheet.validation.missing.value': 'クエリ内の次のフィールドに比較演算子の値が不足しているため、スプレッドシートを実行できません。エラーを修正して再実行してください',
  'Failed to update cell value': 'セル値の更新に失敗しました',
  'Failed to add row': '行の追加に失敗しました',
  'Failed to delete rows': '行の削除に失敗しました',
  'Invalid format selected': '無効なフォーマットが選択されました',
  'Failed to load format data': 'フォーマットデータの読み込みに失敗しました',
  'Invalid format structure - no columns found': '無効なフォーマット構造 - 列が見つかりません',
  'Failed to load format': 'フォーマットの読み込みに失敗しました',
  'Failed to save formats': 'フォーマットの保存に失敗しました',
  'This name has already been used, would you like to overwrite the current format being used by this name?': 'この名前は既に使用されています。この名前で使用されている現在のフォーマットを上書きしますか？',
  'Failed to run spreadsheet': 'スプレッドシートの実行に失敗しました',
  'Format loaded successfully': 'フォーマットが正常に読み込まれました',
  'Failed to load stored format data': '保存されたフォーマットデータの読み込みに失敗しました',
  'Pedigree Data Folders': '系譜データフォルダー',
  'This field is required': 'この項目は必須です',
  'Missing required data for upload. Please ensure all required fields are available.': 'アップロードに必要なデータが不足しています。必須項目がすべて利用可能であることを確認してください。',
  'Spreadsheet Count': 'スプレッドシート件数',
  'There are {displayCount} main row(s) in this spreadsheet': 'このスプレッドシートには主行が %{displayCount} 件あります',
  'Information Message': '情報メッセージ',
  'Number field accepts numeric values only, please re-try.': '数値フィールドには数値のみ入力できます。再度お試しください。',
  'Invalid number': '無効な数値です',
  'Upload Error': 'アップロードエラー',
  'Confirmation message': '確認メッセージ',
  'Upload Success': 'アップロード成功',
  'Overwrite failed': '上書きに失敗しました',
  'Overwrite': '上書き',
  'File upload failed. Please try again.': 'ファイルのアップロードに失敗しました。再度お試しください。',
  'File type not allowed: {fileName}': '許可されていないファイル形式です: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'ファイル "{fileName}" は既に存在します。上書きしますか？',
  'File "{fileName}" uploaded successfully.': 'ファイル "{fileName}" のアップロードに成功しました。',
  'Browse to {value}': '{value} を参照',
  'Open': '開く',
  'Download': 'ダウンロード',
  'Click to view full image for {value}': '{value} の画像全体を表示するにはクリックしてください',
  'Upload Image': '画像をアップロード',
  'Upload Document': 'ドキュメントをアップロード',
  'Yes (Y)': 'はい (Y)',
  'No (N)': 'いいえ (N)',
};